// extracted by mini-css-extract-plugin
export default {"outerFooter":"footer_outerFooter__xqj9d","suport":"footer_suport__oZfT5","copyright":"footer_copyright__oV5y+","copyicon":"footer_copyicon__4KsP1"};